module.exports = __webpack_public_path__ + "static/dedication-background-8db00674c35c288d199a62416ad75c51.jpg";